import { useRef, useEffect, useState } from "react";
import CustomSelect from "./custom-select";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const CasinoFilters = ({ categoryProps, searchProps, dropdownProps }) => {
  const { data: profileData } = useSelector((state) => state.getProfile);
  const containerRef = useRef(null);
  const itemRefs = useRef({});
  const casinoFiltersRef = useRef(null);
  const manuallyOpenedRef = useRef(false);
  const [blockDropdown, setBlockDropdown] = useState(false);
  const { selectedCategory, onCategoryChange, categories, isMobile } =
    categoryProps;

  const { searchValue, onSearch, onClear } = searchProps;

  const {
    selectedProvider,
    handleProviderChange,
    selectedCategoryDropdown,
    handleCategoryDropdownChange,
    categoryOptions,
    options,
  } = dropdownProps;

  // Handler for when dropdown is manually opened - allow it to open
  const handleDropdownOpen = () => {
    if (isMobile) {
      // Mark as manually opened to prevent scroll handler from blocking
      manuallyOpenedRef.current = true;
      setBlockDropdown(false);
    }
  };

  // Handler for when dropdown is closed - reset manual flag
  const handleDropdownClose = () => {
    if (isMobile) {
      manuallyOpenedRef.current = false;
    }
  };

  const visibleCategories = profileData?.user
    ? categories
    : categories?.filter((cat) => cat?.value?.toLowerCase() !== "favourite");

  useEffect(() => {
    if (selectedCategory && itemRefs.current[selectedCategory]) {
      itemRefs.current[selectedCategory].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [selectedCategory, visibleCategories]);

  useEffect(() => {
    if (visibleCategories?.length > 0 && !selectedCategory) {
      onCategoryChange(visibleCategories[0].value);
    }
  }, [visibleCategories, selectedCategory, onCategoryChange]);

  useEffect(() => {
    const header = document.getElementsByClassName("navbar"); // or your header class/id

    if (header) {
      const height = header[0].offsetHeight;

      document.documentElement.style.setProperty(
        "--header-height",
        `${height}px`
      );
    }
  }, []);

  return (
    <div className="casino-filters" ref={casinoFiltersRef}>
      <div className="casino-container-filter">
        <div className="casino-container-search">
          <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
            <path
              d="M18.5436 16.7198L14.0669 12.243C15.2869 10.751 15.8867 8.84709 15.7423 6.92519C15.5979 5.00329 14.7203 3.21042 13.2911 1.91741C11.8619 0.624402 9.99033 -0.0698112 8.06362 -0.0216374C6.13691 0.0265365 4.30241 0.813412 2.9396 2.17623C1.57678 3.53905 0.789903 5.37354 0.741729 7.30025C0.693555 9.22696 1.38777 11.0985 2.68078 12.5277C3.97378 13.9569 5.76666 14.8345 7.68856 14.9789C9.61046 15.1233 11.5143 14.5235 13.0064 13.3035L17.4831 17.7803C17.6246 17.9169 17.814 17.9925 18.0107 17.9908C18.2073 17.9891 18.3954 17.9102 18.5345 17.7711C18.6736 17.6321 18.7524 17.444 18.7541 17.2473C18.7559 17.0507 18.6803 16.8612 18.5436 16.7198ZM8.26339 13.5C7.0767 13.5 5.91666 13.1481 4.92997 12.4888C3.94327 11.8295 3.17423 10.8925 2.72011 9.79612C2.26598 8.69976 2.14716 7.49336 2.37867 6.32948C2.61019 5.16559 3.18163 4.09649 4.02075 3.25738C4.85986 2.41826 5.92896 1.84682 7.09285 1.61531C8.25673 1.3838 9.46313 1.50262 10.5595 1.95674C11.6558 2.41087 12.5929 3.1799 13.2522 4.1666C13.9115 5.15329 14.2634 6.31333 14.2634 7.50002C14.2616 9.09077 13.6289 10.6159 12.5041 11.7407C11.3792 12.8655 9.85414 13.4982 8.26339 13.5Z"
              fill="#97A1C2"
            ></path>
          </svg>
          <input
            type="text"
            placeholder="Search Games"
            value={searchValue}
            onChange={(e) => {
              onSearch(e.target.value);
            }}
            className="search-game"
          />
        </div>
        <div
          className="casino-container-filter-clear"
          onClick={() => {
            onClear();
          }}
        >
          <span className="material-icons">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
              <path
                d="M13 12H17V14H13V12ZM13 4H20V6H13V4ZM13 8H19V10H13V8ZM1 14C1 15.1 1.9 16 3 16H9C10.1 16 11 15.1 11 14V4H1V14ZM12 1H9L8 0H4L3 1H0V3H12V1Z"
                fill="white"
              />
            </svg>
          </span>
        </div>
      </div>
      <div className="bottom-filter">
        {isMobile ? (
          <div className="dropdown">
            <CustomSelect
              options={categoryOptions}
              onChange={handleCategoryDropdownChange}
              value={selectedCategoryDropdown}
              placeholder="Categories"
              blockDropdown={blockDropdown}
              onMenuOpen={handleDropdownOpen}
              onMenuClose={handleDropdownClose}
            />
          </div>
        ) : (
          <div className="filter-categories" ref={containerRef}>
            {visibleCategories && visibleCategories?.length > 0 ? (
              visibleCategories?.map((cat) => (
                <div
                  key={cat.value}
                  ref={(el) => (itemRefs.current[cat.value] = el)}
                  className={`category-item ${
                    selectedCategory === cat.value ? " active" : ""
                  }`}
                  onClick={() => {
                    localStorage.setItem("selectedCat", cat.value);
                    onCategoryChange(cat.value);
                  }}
                >
                  {cat.label}
                </div>
              ))
            ) : (
              <SkeletonTheme baseColor="#2a2d3e" highlightColor="#3e4259">
                {[...Array(6)].map((_, i) => (
                  <Skeleton
                    key={i}
                    width={80}
                    height={20}
                    className="promo-cat cursor-pointer mx-2 my-2"
                  />
                ))}
              </SkeletonTheme>
            )}
          </div>
        )}
        <div className="dropdown">
          <CustomSelect
            options={options}
            onChange={handleProviderChange}
            value={selectedProvider}
            isSearchable={!isMobile}
            placeholder="All Providers"
            blockDropdown={blockDropdown}
            onMenuOpen={handleDropdownOpen}
            onMenuClose={handleDropdownClose}
          />
        </div>
      </div>
    </div>
  );
};
export default CasinoFilters;
